// extracted by mini-css-extract-plugin
export var alt = "Destination-module--alt--79487";
export var cityImage = "Destination-module--cityImage--fca14";
export var container = "Destination-module--container--f4efa";
export var desktopOnly = "Destination-module--desktopOnly--d3956";
export var gatsbyImageWrapper = "Destination-module--gatsby-image-wrapper--1cfae";
export var imageContainer = "Destination-module--imageContainer--c5c4d";
export var main = "Destination-module--main--5c50a";
export var mobileOnly = "Destination-module--mobileOnly--91497";
export var textLeft = "Destination-module--textLeft--19a98";
export var visuallyHidden = "Destination-module--visuallyHidden--a7bf9";